import { render, staticRenderFns } from "./RoomModel.vue?vue&type=template&id=5187f57a&scoped=true&"
import script from "./RoomModel.vue?vue&type=script&lang=js&"
export * from "./RoomModel.vue?vue&type=script&lang=js&"
import style0 from "./RoomModel.vue?vue&type=style&index=0&id=5187f57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187f57a",
  null
  
)

export default component.exports